export class SmrAndAsuAwardsReportFilter {
    countryName: string;
    provinces: string[];
    cities: string[];

    constructor(country, provinces, cities) {
        this.countryName = country;
        this.provinces = provinces;
        this.cities = cities;
    }
}